import React, { useEffect, useMemo, useState } from 'react';
import { decode } from 'base-64';
import { Outlet, useParams } from 'react-router-dom';
import { SHLContext } from '../Contexts';
import PINEntryPage from '../pages/PINEntryPage';
import { isSHLExpired } from '../utils/shlUtil';
import { ErrorTypes } from '../constants';
import { VSError } from '../model/error';

/**
 * Users must complete PIN authentication flow to see children of this route.
 * @returns {import('react').FunctionComponent} React element that enforces authentication.
 */
function ProtectedRoute() {
  const [files, setFiles] = useState([]);
  const [encryptionKey, setEncryptionKey] = useState('');
  const [isExpiryChecked, setIsExpiryChecked] = useState(false);

  // Look at SHL payload to see if PIN is required
  const { shl } = useParams();
  const parsedJSON = JSON.parse(decode(shl));
  const requiresPIN = parsedJSON.flag.includes('P');

  useEffect(() => {
    // Check SHL expiry and throw error if expired
    if (isSHLExpired(shl)) {
      throw new VSError(ErrorTypes.EXPIRED, '', '', 'FHIR_EXP', 'FHIR');
    }
    setIsExpiryChecked(true);
  }, []);

  // If PIN required, then don't show PS home page until required secure files are obtained
  const hasAuthorization = !requiresPIN || (files?.length && encryptionKey);

  const memoizedValue = useMemo(
    () => ({
      files,
      setFiles,
      encryptionKey,
      setEncryptionKey,
    }),
    [files, encryptionKey],
  );

  return (
    isExpiryChecked && (
      <SHLContext.Provider value={memoizedValue}>
        {hasAuthorization ? <Outlet /> : <PINEntryPage shl={parsedJSON} />}
      </SHLContext.Provider>
    )
  );
}

export default ProtectedRoute;
